import React, { useEffect, useState } from "react";
import { AiOutlineCheckCircle, AiOutlineCloudUpload } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import { toast } from "react-toastify";
// import "./drag-drop.css";

const DragNdropFile = ({
  onFilesSelected,
  formatAccepted = ".png, .jpg, .jpeg",
  multiple = false,
  required = false,
  width,
  height,
}) => {
  const [files, setFiles] = useState([]);

  const displayError = (error) => {
    if (error.includes("size")) {
      toast.error(`Taille fichier doit être < 1 Mo.`);
    }

    if (error.length > 1) {
      toast.error(`Extension de fichiers acceptés : ${formatAccepted}`);
    }
  };

  const formatAcceptedFiles = (files, format, prevFiles) => {
    const deniedFormat = [];
    const result = [];

    for (const file of files) {
      const fileParts = file.name.split(".");
      const extension = fileParts[fileParts.length - 1];
      // console.log((file.size / (1024 * 1000)).toFixed(2) > 1);

      if (file.size / (1024 * 2000) > 1) {
        deniedFormat.push("size");
        continue;
      }

      if (!format.includes(extension)) {
        if (!deniedFormat.includes(extension)) {
          deniedFormat.push(extension);
        }
        continue;
      }

      if (!prevFiles.length > 0) {
        result.push(file);
        continue;
      }

      const [flag] = prevFiles.filter(
        (prevfile) => prevfile.name === file.name
      );

      if (flag) {
        continue;
      }

      result.push(file);
    }

    return [result, deniedFormat];
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const selectedFiles = event.target.files;

    if (!selectedFiles && selectedFiles.length <= 0) {
      return;
    }

    const [newFiles, error] = formatAcceptedFiles(
      Array.from(selectedFiles),
      formatAccepted,
      files
    );

    if (error.length > 0) {
      displayError(error);
    }
    console.log(error);

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;

    if (!droppedFiles && droppedFiles.length <= 0) {
      return;
    }

    const [newFiles, error] = formatAcceptedFiles(
      Array.from(droppedFiles),
      formatAccepted,
      files
    );

    console.log(error);
    if (error.length > 0) {
      displayError(error);
    }

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  console.log(files);

  useEffect(() => {
    onFilesSelected(files);
  }, [files, onFilesSelected]);

  return (
    <section className="drag-drop" style={{ width: width, height: height }}>
      <div
        className={`document-uploader upload-box ${
          files.length > 0 ? " active" : ""
        }`}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <>
          <div className="upload-info">
            <AiOutlineCloudUpload />
            <div>
              {/* Déposer vos fichiers images ici. */}
              {/*
                Limite Ajustable en MB par fichier. Fichiers supportés: Ajustable. à la création de l'objet
               */}
            </div>
          </div>
          <input
            type="file"
            name="file"
            hidden
            id="browse"
            onChange={handleFileChange}
            accept={formatAccepted}
            // accept=".pdf,.docx,.pptx,.txt,.xlsx"
            multiple={multiple}
            required={required}
          />
          <label htmlFor="browse" className="browse-btn">
            {/* Limit 1Mo par fichier. Selectionner des fichiers {formatAccepted} */}
            Selectionner des fichiers au format " {formatAccepted} "
          </label>
        </>

        {files.length > 0 && (
          <div className="file-list">
            <div className="file-list__container">
              {files.map((file, i) => (
                <div className="file-item" key={i}>
                  <div className="file-info">
                    {/* <p>{file.name}</p> */}
                    <img
                      src={URL.createObjectURL(file)}
                      alt={file.name}
                      style={{
                        width: "60px",
                        height: "60px",
                        margin: "2px",
                      }}
                    />
                  </div>
                  <div className="file-actions">
                    <MdClear onClick={() => handleRemoveFile(i)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {files.length > 0 && multiple && (
          <div className="success-file">
            <AiOutlineCheckCircle
              style={{ color: "#6DC24B", marginRight: 1 }}
            />
            <div>
              {files.length} fichier{files.length > 1 ? "s" : ""} selectionné
              {files.length > 1 ? "s" : ""}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DragNdropFile;
